/* eslint-disable prefer-rest-params */
import { LibCategories } from "src/utils/consent";
import { loadScript } from "src/utils/scriptLoader";
import {
  MED_PINTEREST_TAG_ID,
  WEIGHT_PINTERST_TAG_ID,
} from "src/utils/constants";
import { shouldFireMedPixel } from "src/utils/userSegment/features";
import { generateEventId } from "src/utils/pixels/utils";

declare const window: Window & {
  pintrk?: any;
};

if (!window.pintrk) {
  window.pintrk = function pintrk() {
    window.pintrk.queue.push(Array.prototype.slice.call(arguments));
  };
  const n = window.pintrk;
  n.queue = [];
  n.version = "3.0";
}

export function loadPinterest() {
  return loadScript("https://s.pinimg.com/ct/core.js", [
    LibCategories.targetingCookies,
  ]).then(() => {
    const { pintrk } = window;

    // Always load Med pixel on all pages (med + weight)
    pintrk("load", MED_PINTEREST_TAG_ID);
    pintrk("page", { page_name: "Noom", page_category: "health" });
    const medEventId = generateEventId();
    pintrk("track", "pagevisit", {
      event_id: medEventId,
    });

    // For weight pages, also load weight pixel and fire pagevisit
    if (!shouldFireMedPixel()) {
      pintrk("load", WEIGHT_PINTERST_TAG_ID);
      pintrk("page", { page_name: "Noom", page_category: "health" });
      const weightEventId = generateEventId();
      pintrk("track", "pagevisit", {
        event_id: weightEventId,
      });
    }
  });
}
